import { tyreBrandService } from '../../helpers/services/tyreBrand.service';
import i18n from '@/i18n'
import { sharedHelper, filtersHelper } from '@/utils'
import router from '@/router/index'

export const state = {
    list: {
        data: [],
        pagination: {
            pageNumber: 0,
            pageSize: 0,
            lastPage: 0,
            tableRowsCount: 0
        }
    },
    details: {},
    status: {}
}

export const TYRE_BRAND_MODULE = 'tyreBrand';

// define action 
export const GET_ALL_TYRE_BRANDS = 'getAlltyreBrands';
export const GET_TYRE_BRAND = 'gettyreBrand';
export const UPDATE_TYRE_BRAND = 'updatetyreBrand';
export const CREATE_TYRE_BRAND = 'createtyreBrand';
export const UPDATE_TYRE_BRAND_STATUS = 'updatetyreBrandStatus';

// define mutation
const SUCCESS = "commonSuccess";
const SUCCESS_WITHOUT_REDIRECT = "successWithoutRedirect";
const FAILURE = "commonFailure";
const REQUEST = "commonRequest";
const GET_ALL_TYRE_BRANDS_REQUEST = "getAlltyreBrands";
const GET_TYRE_BRAND_REQUEST = "gettyreBrand";

export const actions = {
    // eslint-disable-next-line no-unused-vars
     [GET_ALL_TYRE_BRANDS]({ commit }, { filter }) {
         tyreBrandService
            .getAlltyreBrands(filter)
            .then(
                (result) => {
                    commit(GET_ALL_TYRE_BRANDS_REQUEST, result)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                }
            )
    },

    // eslint-disable-next-line no-unused-vars
     [GET_TYRE_BRAND]({ commit }, { id }) {
        tyreBrandService
            .gettyreBrand(id)
            .then(
                (result) => {
                    commit(GET_TYRE_BRAND_REQUEST, result)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                }
            );
    },

    // eslint-disable-next-line no-unused-vars
    [UPDATE_TYRE_BRAND]({ commit }, { data }) {
        commit(REQUEST)
        tyreBrandService
            .updatetyreBrand(data)
            .then(
                // eslint-disable-next-line no-unused-vars
                (result) => {
                    var message = i18n.t("message.updateXSuccess", [i18n.t('module.tyreBrand')]);
                    sharedHelper.alertSuccessMessage(message)
                    commit(SUCCESS)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                    commit(FAILURE)
                }
            )
    },

    // eslint-disable-next-line no-unused-vars
    [CREATE_TYRE_BRAND]: async ({ commit }, { redirect, data }) => {
        commit(REQUEST);
        var return_result = [];
        try {
            var result = await tyreBrandService.createtyreBrand(data);
            return_result['type_uuid'] = result.data.uuid;
            const message = i18n.t("message.createXSuccess", [i18n.t('module.tyreBrand')]);
            sharedHelper.alertSuccessMessage(message);

            if (redirect) {
                commit(SUCCESS);
            } else {
                commit(SUCCESS_WITHOUT_REDIRECT);
            }

            return_result['result'] = true

        } catch (error) {
            const message = sharedHelper.getErrorMessage(error);
            sharedHelper.alertErrorMessage(message, error.response?.data?.code);
            commit(FAILURE);
            return_result['result'] = false
        }

        return return_result;

    },

    // eslint-disable-next-line no-unused-vars
    [UPDATE_TYRE_BRAND_STATUS]({ dispatch }, { filter, data }) {
        tyreBrandService
            .updatetyreBrandStatus(data)
            .then(
                // eslint-disable-next-line no-unused-vars  
                (result) => {
                    var message = i18n.t('message.updateStatusSuccess');
                    sharedHelper.alertSuccessMessage(message)
                    dispatch(GET_ALL_TYRE_BRANDS, { filter })
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                }
            )
    },


};

export const mutations = {

    [SUCCESS](state) {
        state.status = {};
        router.push({ name: "Tyre-brand-listing" });
    },
    [SUCCESS_WITHOUT_REDIRECT](state) {
        state.status = {};
    },
    [FAILURE](state) {
        state.status = {};
    },
    [REQUEST](state) {
        state.status = { update: true, create: true };
    },
    [GET_ALL_TYRE_BRANDS_REQUEST](state, data) {
        let d = data.data

        state.list.pagination = sharedHelper.apiPaginationAdapter(data.pagination)

        state.list.data = d.map((o) => {
            return {
                uuid: o.uuid,
                name: o.name,
                isActive: o.is_active,
                createdBy: o.created_by,
                image: o.image,
                createdDateTime: filtersHelper.getDateFormat(o.created_date_time),
                updatedBy: o.updated_by,
                updatedDateTime: filtersHelper.getDateFormat(o.updated_date_time)
                
            }
        })
    },
    [GET_TYRE_BRAND_REQUEST](state, data) {
        let o = data.data
        
        state.details = {
            uuid: o.uuid,
            name: o.name,
            isActive: o.is_active,
            createdBy: o.created_by,
            image: o.image,
            createdDateTime: filtersHelper.getDateFormat(o.created_date_time),
            updatedBy: o.updated_by,
            updatedDateTime: filtersHelper.getDateFormat(o.updated_date_time)
        }
    }
}


